import rulePoint from "@/components/rule/rulePoint";
import ruleFence from "@/components/rule/ruleFence";
import ruleLine from "@/components/rule/ruleLine";
import ruleCount from "@/components/rule/ruleCount";
import ruleSpeed from "@/components/rule/ruleSpeed";
import ruleNotice from "@/components/rule/ruleNotice";
import ruleStay from "@/components/rule/ruleStay";
var data = [
  {
    path: "/rulePoint",
    component: rulePoint
  },
  {
    path: "/ruleLine",
    component: ruleLine
  },
  {
    path: "/ruleFence",
    component: ruleFence
  },
  {
    path: "/ruleSpeed",
    component: ruleSpeed
  },
  {
    path: "/ruleCount",
    component: ruleCount
  },
  {
    path: "/ruleNotice",
    component: ruleNotice
  },
  {
    path: "/ruleStay",
    component: ruleStay
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/rule.js